import { BsesAutomation, PayrollAutomation } from "../assets/HomePage";
export const clients = Object.freeze({
  BSES: "bses",
  GI_GROUP: "gigroup"
});

export const CASE_STUDIES = {
  [clients.BSES]: {
    title: "Automating Defaulter Recovery for BSES",
    client: "BSES Yamuna Power Ltd. (BYPL)",
    description:
      "A leading Delhi-based power distribution company serving millions, known for operational efficiency and service reliability.",

    image: BsesAutomation,

    problemPoints: [
      "Manual recovery process repeated every 6 days.",
      "A team of 10 people took 15+ days to complete one cycle.",
      "~5% error rate leading to approximately 10% revenue leakage.",
      "Data from 14 divisions was manually fetched, categorized and allocated."
    ],

    solutions: [
      "Data Extraction from BIW across all 14 divisions.",
      "File Consolidation by merging all extracted files into a single dataset.",
      "Intelligent Categorization for Sticky, Chronic, Never Paid and other recovery categories.",
      "Auto Allocation of cases to field executives based on predefined rules.",
      "DTM Upload Automation with deduplication and smart file handling.",
      "Oracle Database Integration for centralized tracking and reporting."
    ],

    impacts: [
      { value: "85%", label: "Reduction in Manual Work" },
      { value: "100%", label: "Classification Accuracy" },
      { value: "0%", label: "Revenue Leakage" },
      { value: "Minutes", label: "Processing Time" },
      { value: "6 Days", label: "Automated Cycle" }
    ],

    outcome:
      "Faster recovery cycles, improved operational efficiency, complete case tracking and zero revenue leakage.",

    technology:
      "RPA, BIW Integration, DTM Integration, Oracle Database, Intelligent Categorization Engine"
  },

  [clients.GI_GROUP]: {
    title: "Salary Automation for Gi Group",
    client: "Major Staffing Company",

    description:
      "A global staffing and HR solutions provider managing salary processing for 50,000–60,000 employees across multiple clients.",

    image: PayrollAutomation,

    problemPoints: [
      "Manual salary processing by 4 full-time employees took an entire month.",
      "Delays led to 10+ day average late payments.",
      "3–5% error rate including duplicate payments and reconciliation gaps.",
      "No centralized system to track failed, hold or cancelled transactions."
    ],

    solutions: [
      "Bank Text File Generator – Auto-generates salary files.",
      "Bank Tracker – Captures paid, hold and rejected transactions.",
      "UTR Navision Uploader – Tracks incoming funds.",
      "Payout Uploader – Records outgoing salary distribution.",
      "Cancellation Uploader – Tracks cancelled payments.",
      "Reconciliation Sheet Uploader – Complete audit trail."
    ],

    impacts: [
      { value: "30 Days → Minutes", label: "Salary Disbursal" },
      { value: "100%", label: "Duplicate Elimination" },
      { value: "~0%", label: "Error Rate" },
      { value: "100%", label: "Visibility" },
      { value: "Improved", label: "Employee Trust" }
    ],

    outcome:
      "Faster payroll processing, accurate payments, zero duplicates and improved operational efficiency.",

    technology:
      "RPA, ERP (Navision), Bank Integrations, Excel Automation"
  }
};